// extracted by mini-css-extract-plugin
export var hidden = "_pt-1";
export var visible = "_pt-0";